import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import Badge from '@mui/material/Badge';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import NavItem from './NavItem';

const CustomBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    color: theme.palette.primary.main,
    top: '-10px',
    right: '-5px',
    fontSize: 11,
  },
}));

function OrdersNavItem(props) {
  const {
    width,
    iconwidth,
    iconheight,
    marginright,
    boxshadow,
    colorhover,
    backgroundcolor,
    backgroundcolorhover,
    badgeContent,
  } = props;
  const { t } = useTranslation();
  return (
    <NavItem
      aria-label="orders"
      to="/orders"
      width={width}
      iconwidth={iconwidth}
      iconheight={iconheight}
      marginright={marginright}
      boxshadow={boxshadow}
      colorhover={colorhover}
      backgroundcolor={backgroundcolor}
      backgroundcolorhover={backgroundcolorhover}
      title={t('Orders')}
    >
      <CustomBadge badgeContent={badgeContent} color="secondary" max={badgeContent}>
        <AssignmentTurnedInIcon color="blue" />
      </CustomBadge>
    </NavItem>
  );
}

OrdersNavItem.propTypes = {
  width: PropTypes.number,
  iconwidth: PropTypes.number,
  iconheight: PropTypes.number,
  boxshadow: PropTypes.string,
  backgroundcolorhover: PropTypes.string,
  colorhover: PropTypes.string,
  backgroundcolor: PropTypes.string,
  badgeContent: PropTypes.number,
  marginright: PropTypes.number,
};

OrdersNavItem.defaultProps = {
  width: 0,
  iconwidth: 16,
  iconheight: 16,
  backgroundcolor: '',
  backgroundcolorhover: '#fff',
  colorhover: '',
  boxshadow: '',
  marginright: 10,
};

export default OrdersNavItem;
